import React, { useMemo } from "react";
import { IonRadio, IonRadioGroup, IonItem, IonLabel } from "@ionic/react";
export function Preferences_Radio({
  preferenceList,
  content,
  option,
  handleChange,
  handleCheck
}: any) {
  return (
    <>
      {useMemo(
        () => (
          <IonRadioGroup
            onIonChange={e =>
              handleChange(e, content.API_KEY, content.OPTION_TYPE)
            }
            name={option.OPTION_VALUE}
            value={handleCheck(content.API_KEY, content.OPTION_TYPE, null)}
          >
            <IonItem key={option.OPTION_TITLE}>
              <IonRadio
                value={option.OPTION_VALUE}
                name={content.API_KEY}
                class="radiobutton"
                mode="md"
              />
              <IonLabel className="preference-label">{option.OPTION_TITLE}</IonLabel>
            </IonItem>
          </IonRadioGroup>
        ),
        [preferenceList]
      )}
    </>
  );
}
